import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type NavSection = 'name' | 'logos' | 'monetization' | 'privacy';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsNavService {
  private readonly activeSection$ = new BehaviorSubject<NavSection>('name');
  private scrollLock = false;

  getActiveSection() {
    return this.activeSection$.asObservable();
  }

  isScrollLocked() {
    return this.scrollLock;
  }

  setActiveSection(section: NavSection) {
    this.activeSection$.next(section);
  }

  scrollToSection(section: NavSection) {
    this.setActiveSection(section);
    this.scrollLock = true;

    const element = document.getElementById(`section-${section}`);
    const scrollContainer = document.querySelector(
      '.settings-subcontainer .flex-1.overflow-y-auto',
    );

    if (element && scrollContainer) {
      const yOffset = -24;

      const containerRect = scrollContainer.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();

      const elementTopRelativeToContainerViewport = elementRect.top - containerRect.top;
      const targetScrollTop =
        scrollContainer.scrollTop + elementTopRelativeToContainerViewport + yOffset;

      scrollContainer.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
    } else if (element) {
      const yOffset = -24;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    } else {
      console.warn(`Element with ID 'section-${section}' not found for scrolling.`);
    }

    // unlock after scroll animation
    setTimeout(() => {
      this.scrollLock = false;
    }, 800);
  }
}
